module.exports = __webpack_public_path__ + "media/images/emblems/LaGrandeBeroche-blazon-09451badcb7f16d9bfd5c64c0b146be8.svg";